module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fbm-thresholds-inline"
  }, [_c('div', {
    staticClass: "fbm-inline-title"
  }, [_c('i', {
    staticClass: "cog icon"
  }), _vm._v(" "), _c('span', [_vm._v("Alert Threshold — " + _vm._s(_vm.productTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "fbm-inline-fields"
  }, [_c('div', {
    staticClass: "fbm-mkt-group"
  }, [_c('div', {
    staticClass: "fbm-mkt-group-label"
  }, [_c('i', {
    class: _vm.getMarketplaceFlag(_vm.item && _vm.item.marketplace ? _vm.item.marketplace : null) + ' flag'
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.marketplaceLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "fbm-mkt-fields"
  }, [_c('div', {
    staticClass: "fbm-inline-field"
  }, [_c('label', [_vm._v("Alert below")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.redThreshold),
      expression: "form.redThreshold",
      modifiers: {
        "number": true
      }
    }],
    class: ['fbm-inline-input', _vm.fbmInputFilled],
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "—",
      "disabled": !_vm.resolvedProductId
    },
    domProps: {
      "value": (_vm.form.redThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "redThreshold", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fbm-field-unit"
  }, [_vm._v("units")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "fbm-inline-actions"
  }, [_c('button', {
    staticClass: "fbm-btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.resolvedProductId
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "fbm-btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('span', {
    staticClass: "fbm-inline-hint"
  }, [_vm._v("Alert fires when your FBM stock drops below this level.")])]), _vm._v(" "), (_vm.saveError) ? _c('div', {
    staticClass: "fbm-inline-error"
  }, [_vm._v(_vm._s(_vm.saveError))]) : _vm._e(), _vm._v(" "), (_vm.saving) ? _c('div', {
    staticClass: "fbm-inline-loading"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" Saving…\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52d3b922!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/issues/FBMAlertThresholdsInline.vue
// module id = 774
// module chunks = 2